(() => {
  for (const root of document.querySelectorAll('[data-home-ceiling]')) {
    if (root.dataset.bound) continue;
    root.dataset.bound = 'true';
    const panel = root.closest('[data-orbit-item]');
    const host = root.querySelector('.exo-home-ceiling__viewer');
    const template = root.querySelector('[data-ceiling-template]');
    const loading = root.querySelector('.exo-home-ceiling__loading');
    let inView = false;
    let frame = null;
    function sync() {
      const selected = !panel || !panel.hidden;
      if (!selected && frame) {
        frame.remove(); frame = null;
        loading.style.display = '';
        root.dataset.loaded = 'false';
      }
      if (selected && inView && !frame) {
        frame = template.content.firstElementChild.cloneNode(true);
        frame.addEventListener('load', () => { loading.style.display = 'none'; }, {once:true});
        host.append(frame);
        root.dataset.loaded = 'true';
      }
    }
    const visibility = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      sync();
    }, {rootMargin:'100px 0px'});
    visibility.observe(root);
    if (panel) new MutationObserver(sync).observe(panel,{attributes:true,attributeFilter:['hidden']});
  }
})();
